import React, { useState } from "react";
import "../css/contactus.scss";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Invalid email address";
    }
    if (!formData.message.trim()) newErrors.message = "Message is required";
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setIsSubmitting(true);
    setTimeout(() => {
      setShowSuccess(true);
      setFormData({ name: "", email: "", message: "" });
      setIsSubmitting(false);
      setTimeout(() => setShowSuccess(false), 5000);
    }, 1000);
  };

  return (
    <div className="contact-container">
      <div className="contact-content">
        <h1>CONTACT US</h1>
        
        <div className="contact-info">
          <p>Welcome to baplehollow. It is nice to have you here.</p>
          
          <p>
            For product, delivery, return or privacy questions, email us at{" "}
            <a href="mailto:model@baplehollow.online">model@baplehollow.online</a>.
          </p>

          <div className="info-section">
            <p>Business entity:</p>
            <p>Hong Kong Ruijingsheng Trading Co., Limited</p>
          </div>

          <div className="info-section">
            <p>Business address:</p>
            <p>
              RM 12, UNIT 12A, 13/F, BLOCK 1,<br />
              CAMEL PAINT BUILDING,<br />
              62 HOI YUEN ROAD,<br />
              KWUN TONG, HONG KONG
            </p>
          </div>

          <div className="info-section">
            <p>Customer care:</p>
            <p>We normally reply within two business days.</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="name">Name <span>*</span></label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                className={errors.name ? "error" : ""}
              />
              {errors.name && <span className="error-msg">{errors.name}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="email">Email <span>*</span></label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className={errors.email ? "error" : ""}
              />
              {errors.email && <span className="error-msg">{errors.email}</span>}
            </div>
          </div>

          <div className="form-group full-width">
            <label htmlFor="message">Message <span>*</span></label>
            <textarea
              id="message"
              name="message"
              rows="6"
              value={formData.message}
              onChange={handleInputChange}
              className={errors.message ? "error" : ""}
            ></textarea>
            {errors.message && <span className="error-msg">{errors.message}</span>}
          </div>

          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? "SENDING..." : "SEND"}
          </button>

          {showSuccess && (
            <div className="success-message">
              Thank you! Your message has been sent.
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

export default Contact;
